import { Field } from 'ngx-angular-query-builder';
import { FilterOperators, FieldMetadataCollection, FilterFieldProvider } from '@common/filter/filtering';
import { WidgetConfiguration } from '@feature/widget-configs';

export class AdminPmaDocumentCentreWidgetFilterFieldProvider implements FilterFieldProvider {

  private readonly fieldMetaDataCollection = new FieldMetadataCollection();

  constructor(widgetConfig: WidgetConfiguration) {

    const d = this.fieldMetaDataCollection;

    const isInternal = widgetConfig.widgetTypeId === 'MojoDocumentCentre';

    d.addFilter('Date Added', 'DateAdded', 'date', FilterOperators.AdminDateDefaults);
    d.addFilter('Linked To', 'LinkedTo', 'string', FilterOperators.AdminStringDefaults);
    d.addFilter('Category', 'Category', 'string', FilterOperators.AdminStringDefaults);
    d.addFilter('Description', 'Description', 'string', FilterOperators.AdminStringDefaults);
    d.addFilter('Added By', 'AddedBy', 'string', FilterOperators.AdminStringDefaults);
    d.addFilter('File Type', 'FileType', 'string', FilterOperators.AdminStringDefaults);
    d.addFilter('File Name', 'FileName', 'string', FilterOperators.AdminStringDefaults);


    if (isInternal) {
      d.addFilter('Expiry Date', 'ExpiryDate', 'date', FilterOperators.AdminDateDefaults);
      d.addFilter('Status', 'Status', 'string', FilterOperators.AdminStringDefaults);
      d.addFilter('Visibility', 'Visibility', 'string', FilterOperators.AdminStringDefaults);
    }

  }

  getFilterFields(): Array<Field> {
     return this.fieldMetaDataCollection.getFilterFields();
  }

  getFieldNameFromLabel(label: string): string {
    return this.fieldMetaDataCollection.getFieldNameFromLabel(label);
  }

  getFilterField(fieldName: string): Field {
     return this.fieldMetaDataCollection.getFilterField(fieldName);
  }


}
